const HomepageCarouselItem = ({ promo, onClick, isActive }) => {
  const { title, url, imageUrl } = promo;

  return (
    <div className={`slide-item ${isActive ? 'active' : ''}`}>
      <a href={url} onClick={onClick}>
        <img
          src={imageUrl}
          alt={title}
          width="1190"
          height="350"
          fetchPriority="high"
        />
      </a>
    </div>
  );
};

export default HomepageCarouselItem;
